/* eslint-disable react/prefer-stateless-function */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Authorization from '../Authorization';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE } from '../../constants';

class Files extends Component {
  render() {
    let { files } = this.props;

    if (!files) {
      files = [];
    }

    return (
      <Fragment>
        {files.length > 0 && (
          <div className="col-md-12 mt-10 mb-10">
            <h4>Archivos</h4>

            <Authorization allowed={['guest', 'user']}>
              <div
                className="alert alert-warning wow fadeInLeft delay-03s"
              >
                <strong>¡Bienvenido!</strong>
                Para descargar estos archivos, debes tener un plan pagado.
              </div>
            </Authorization>
          </div>)
        }

        {files
          .map(link => (
            <div key={link.name} className="col-md-4">

              <Authorization allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                <a target="_blank" rel="noopener noreferrer" href={link.value}>
                  <i className="fa fa-file pr-5" aria-hidden="true" />
                  {link.name}
                </a>
              </Authorization>
              <Authorization denied={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                <span>
                  <i className="fa fa-file pr-5" aria-hidden="true" />
                  {link.name}
                </span>
              </Authorization>

            </div>
          ))}
      </Fragment>
    );
  }
}

Files.propTypes = {
  files: PropTypes.array.isRequired,
};

export default Files;



// WEBPACK FOOTER //
// ./src/components/Files/index.js